import React from "react";
import "../General/General.css";
import CVTemplate from "./CVTemplate";
import {useFlag} from "@unleash/proxy-client-react";
import ENUMS from "../General/Enums";

export default function MyCV() {
    if (useFlag(ENUMS.MyCV)) {
        return <CVTemplate jobId={0}/>
    } else {
        return null
    }

}